import React from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import infoIcon from "icons/info-new-rows.svg";
import { modalTypes } from "constants/types";
import { deleteWorkspace } from "slices/systemAdmin/actions/systemAdmin";

const DeleteWorkspaceModal = ({ workspaceName, workspaceId }) => {
  const dispatch = useDispatch();

  const handleConfirmation = () => {
    dispatch(deleteWorkspace(workspaceName, workspaceId));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.DELETE_WORKSPACE));
  };

  const modalBody = () => (
    <div className="delete__workspace__modal">
      <div className="delete__workspace__modal__icon">
        <img src={infoIcon} alt="info icon" />
      </div>
      <div className="delete__workspace__modal__info">
        <p>
          We will delete all data contained in the{" "}
          <b>{workspaceName} Workspace </b>
          (folders, documents, dictionaries and associated analysis). This
          action cannot be undone.
        </p>
        <p>
          Members that only exist in this workspace will be deleted from the
          system completely.
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      data-testid="deleteWorkspaceModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>Delete Workspace</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          data-test="saveButton"
          variant={buttonVariants.primary}
          onClick={() => {
            handleConfirmation();
          }}
          disabled={false}
          content="Permanently Delete"
        />
        <Button
          data-test="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteWorkspaceModal;

DeleteWorkspaceModal.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
};
